import { TagListPage } from './TagListPage';
export default TagListPage;
